import React, { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import './Layout.css';

function Layout() {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  const handleClickOutside = () => {
    if (showUserMenu) {
      setShowUserMenu(false);
    }
  };

  const navigateTo = (path) => {
    setShowUserMenu(false);
    navigate(path);
  };

  return (
    <div className="layout" onClick={handleClickOutside}>
      <header className="header">
        <div className="system-name">工具箱系统</div>
        <div className="user-container" onClick={(e) => e.stopPropagation()}>
          <div className="user-name" onClick={toggleUserMenu}>
            张三
            <span className="dropdown-icon">▼</span>
          </div>
          {showUserMenu && (
            <div className="user-menu">
              <div className="user-menu-item" onClick={() => navigateTo('/profile')}>
                个人信息
              </div>
              <div className="user-menu-item" onClick={() => navigateTo('/settings')}>
                设置
              </div>
              <div className="user-menu-item logout">
                退出登录
              </div>
            </div>
          )}
        </div>
      </header>
      <div className="main-container">
        <div className="sidebar">
          <h2 className="sidebar-title">工具箱</h2>
          <nav className="sidebar-nav">
            <ul>
              <li>
                <Link to="/timestamp">时间戳转换</Link>
              </li>
              <li>
                <Link to="/md5">MD5生成器</Link>
              </li>
              <li>
                <Link to="/test">测试页面</Link>
              </li>
              <li>
                <Link to="/move">移动</Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout; 